/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Project_Info_ModalInputs */



/**
* | output |
* | --- |
* | "Close project info modal" |
*
* @param {Close_Project_Info_ModalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_project_info_modal = /** @type {((inputs?: Close_Project_Info_ModalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Project_Info_ModalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la fenêtre d’infos du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektinfo-Modal schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi la finestra modale delle informazioni sul progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть модальное окно с информацией о проекте")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar el modal de información del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭项目信息模态框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト情報モーダルを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट जानकारी मॉडल बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar modal de informações do projeto")
	return /** @type {LocalizedString} */ ("Close project info modal")
});